import { css } from '@emotion/react'
import { Image } from 'components/Image'
import { SelectedMemory } from 'components/memory/MemoryUtils'
import { ModalConfig, useModal } from 'components/modal/Modal'
import { BlockSpinner } from 'components/spinner/Spinner'
import { ReactNode } from 'react'
import { useDynamicTranslations } from 'utils/i18n/useDynamicTranslations'
import { BREAKPOINTS, pxToRem } from 'utils/styled'
import { SPreviewContainer, SShareItems, SShareModal, STitle } from './MemoryShareModal.styled'

const modalConfig: ModalConfig = {
  modalCss: css`
    @media ${BREAKPOINTS.MD.min} {
      max-width: ${pxToRem(400)}rem;
    }
  `,
}

const MemoryShareModal = (props: {
  close?: () => void
  memory?: SelectedMemory
  title?: ReactNode
}) => {
  const { t, isLoading } = useDynamicTranslations('memory')
  if (isLoading) return <BlockSpinner />
  return (
    <SShareModal>
      <STitle>{props.title || t('memory.memory_id.share_modal_fallback_title')}</STitle>
      <SPreviewContainer>
        <Image src={props.memory?.original_file?.url} />
      </SPreviewContainer>
      <SShareItems memory={props.memory} onFutureMessage={props.close} isModal={true} />
    </SShareModal>
  )
}

export const useMemoryShareModal = (memory?: SelectedMemory, title?: ReactNode) => {
  const [shareModal, openShareModal, closeShareModal] = useModal(
    ({ close, isOpen }) =>
      isOpen ? <MemoryShareModal memory={memory} close={close} title={title} /> : null,
    modalConfig
  )
  return [shareModal, openShareModal, closeShareModal] as const
}
